import { useCallback, useContext, useEffect, useState } from "react";
import { NumberOfferContext } from "../App";
import { ICart } from "@features/cart/ICart";
import { getProspectReference } from "@utils/storage";
import { getResponseToState, ICartResponse } from "@mappers/getCartMapper";
import { useFetch } from "./useFetch";
import { getCartRoute } from "@api-routes/eirSalesFacade";
import { getCartItemsNumber } from "@utils/getCartItemsNumber";

export const useGetCart = (callback?: (cart: ICart | undefined) => void) => {
    const [cart, setCart] = useState<ICart | undefined>();
    const [initialCart, setInitialCart] = useState<ICart | undefined>();
    const [cartState, { get }] = useFetch();
    const { setNumberOfferSelected } = useContext(NumberOfferContext);

    const getCart = useCallback(() => {
        const prospectReference = getProspectReference();

        if (prospectReference) {
            get<ICartResponse>(getCartRoute(prospectReference), {
                headers: {
                    "Cache-Control": "no-cache",
                },
            }).then((cartResponse) => {
                if (cartResponse) {
                    const newCart = getResponseToState(cartResponse);

                    setNumberOfferSelected(getCartItemsNumber(newCart));
                    setCart(newCart);
                    if (!initialCart) {
                        setInitialCart(newCart);
                    }

                    if (callback) {
                        callback(newCart);
                    }
                } else if (callback) {
                    callback(undefined);
                }
            });
        } else if (callback) {
            callback(undefined);
        }
    }, [callback, get, setNumberOfferSelected]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(getCart, []);

    return { initialCart, cart, setCart, cartState, getCart };
};
